<svelte:options tag={null} />

<script lang="ts">
  import type { TextInputSize, TextInputType } from './textinput.types';

  export let name: string;
  export let value: string;
  export let placeholder: string;
  export let inputtype: TextInputType = 'text';
  export let isvalid: boolean;
  export let isinvalid: boolean;
  export let disabled = false;
  export let size: TextInputSize = 'm';
  export let iconname: string;
  export let rightalign: boolean;
  export let min: string;
  export let max: string;

  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function generateIconName(iconName: string): string {
    return `${iconName}`;
  }

  function getClasses(
    isValid: boolean,
    isInvalid: boolean,
    size: TextInputSize,
    iconname: string,
  ): string {
    const classes = ['mc-text-input', 'mc-field__input'];

    if (isValid) {
      classes.push('is-valid');
    }

    if (isInvalid) {
      classes.push('is-invalid');
    }

    if (size === 's') {
      classes.push('mc-text-input--s');
    }

    if (iconname) {
      classes.push('mc-left-icon-input__input');
    }

    if (rightalign) {
      classes.push('right-align');
    }

    return classes.join(' ');
  }

  const setType = (node: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    node.type = inputtype;
  };
</script>

<div class="{iconname ? 'mc-left-icon-input' : ''} {userClass}" {...attributes}>
  {#if iconname}
    <span class="mc-left-icon-input__icon">
      {@html `<${generateIconName(iconname)} />`}
    </span>
  {/if}
  <input
    bind:value
    use:setType
    class="{getClasses(
      isvalid,
      isinvalid,
      size,
      iconname,
    )} {$$props.classinput}"
    aria-invalid={isinvalid}
    {name}
    id={name}
    {placeholder}
    {disabled}
    {min}
    {max}
    spellcheck="false"
    on:input
    on:click
  />
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.text-input';
  @import '@mozaic-ds/styles/components/c.left-icon-input';
  @import '@mozaic-ds/styles/components/c.fields';

  .right-align {
    text-align: right;
  }
</style>
